import { Product, useJurisdictionStore } from './use-jurisdiction';

export const useIsPredictionsProduct = () => useJurisdictionStore(state => state.product === Product.Prediction);
